import {useDataGrid} from "./data-grid/DataGridContext";
import ApiService from "../Service/ApiService";
import {useEffect, useState} from "react";
import DataGrid from "./data-grid/DataGrid";
import {Card, Dropdown, Menu, Spin, Tooltip, Typography} from "antd";
import {useModal} from "../Context/ModalContext";
import {useProject} from "../Context/ProjectContext";
import {array} from "plotly.js/src/components/errorbars/attributes";
import {useHistory} from "react-router-dom";
import HecRasHelper from "../Helpers/HecRasHelper";
import {unzipToJson} from "./ProjectUploader";

export default function ProjectTable({bottom, onUpload}) {
    const {setData, setPaginationResult, queryModel, setDataGridProps, refreshDataGrid} = useDataGrid();
    const [load, setLoad] = useState({
        title: '',
        status: false,
    })
    const history = useHistory()
    const {openModal, closeModal} = useModal()

    const initGridData = async () => {
        const response = await ApiService.UserProject.GetProjectsGrid(queryModel)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel])

    const renderDesc = (desc) => {
        let text = desc
        if(Array.isArray(desc))
            text = desc?.filter(x => x.trim())?.join('\n')

        return (
            <Tooltip
                overlayStyle={{width: 400}}
                placement={'left'}
                title={() => (
                    <div style={{whiteSpace: 'pre-line', height: 250, overflowY: 'auto'}}>
                        {text}
                    </div>
                )}
            >
                <Typography.Text ellipsis={true} style={{width: 400}}>
                    {text}
                </Typography.Text>
            </Tooltip>
        )
    }


    const renderMenu = (text, row) => {
        return (
            <>
                <Dropdown
                    trigger={['click']}
                    overlay={(
                        <Menu>
                            <Menu.Item
                                key={'load_project_model_a'}
                                onClick={async () => {
                                    setLoad({
                                        title: row?.title,
                                        status: true
                                    })
                                    const res = await ApiService.UserProject.GetProjectState(row?.key);
                                    setLoad({
                                        title: row?.title,
                                        status: false
                                    })
                                    if(res.success) {
                                        let project = await unzipToJson(res.data)
                                        project = HecRasHelper.checkProjectFiles(project)
                                        onUpload && onUpload(project)

                                        history.push('/app/load-project')
                                        closeModal()
                                    }
                                }}
                            >
                                Load Project
                            </Menu.Item>

                            <Menu.Item
                                key={'delete_project'}
                                onClick={async () => {
                                    const res = await ApiService.UserProject.DeleteProject(row?.key)
                                    if(res.success) {
                                        refreshDataGrid()
                                    }
                                }}
                            >
                                Delete Project
                            </Menu.Item>
                        </Menu>
                    )}
                >
                    <a onClick={(e) => e.preventDefault()}>
                        <Typography.Text ellipsis={true} style={{width: 250, color: '#3498db'}}>
                            {text}
                        </Typography.Text>
                    </a>
                </Dropdown>
            </>
        )
    }

    useEffect(() => {
        setDataGridProps({
            rowKey: 'key',
            enableRowSelection: false,
            columns: [
                {title: 'Date', dataIndex: 'createdDate', key: 'createdDate', sorter: false, render: (text, record) => `${new Date(text).toLocaleString()}`, width: 150},
                {title: 'Project Title', dataIndex: 'title', key: 'title', sorter: false, width:250, render: renderMenu},
                {title: '# of Plans', dataIndex: 'planCount', key: 'planCount', sorter: false, width: 80},
                {title: 'Project Description', dataIndex: 'description', key: 'description', sorter: false, render: renderDesc, width: 400},
                {title: 'Notes', dataIndex: 'notes', key: 'notes', sorter: false, render: renderDesc, width: 400},
            ],
        })
    }, [])

    return (
        <>
            {
                load?.status && (
                    <div>
                        <Typography.Text>
                            Projects {load.title} is loading...
                        </Typography.Text>
                        <Spin spinning={true} style={{marginLeft: 12}} />
                    </div>
                )
            }
            <DataGrid/>
            {bottom && bottom()}
        </>
    )
}